import { render, staticRenderFns } from "./podcasts.vue?vue&type=template&id=d438ad0c&"
import script from "./podcasts.vue?vue&type=script&lang=js&"
export * from "./podcasts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports